import { useChangePassword } from 'api-hooks/employee/mutation';
import formSetErrors from 'common/helpers/form-setError';
import notification from 'components/common/notification';
import { Form, Input } from 'components/elements';
import FormHeader from 'components/widgets/form-header';
import useNavigation from 'hooks/use-navigation';
import useYupValidationResolver from 'hooks/use-yup-validation-resolver';
import { HalfContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

type FormType = {
  oldPassword: string;
  password: string;
  passwordConfirmation: string;
};

export default function ChangePassword() {
  const { t } = useTranslation();
  const { close } = useNavigation();
  const { mutateAsync } = useChangePassword();

  const yupSchema = React.useMemo(
    () =>
      Yup.object()
        .shape({
          oldPassword: Yup.string().required(),
          password: Yup.string().required(),
          passwordConfirmation: Yup.string().required(),
        })
        .required(),
    [],
  );

  const resolver = useYupValidationResolver(yupSchema);

  const methods = useForm<FormType>({
    resolver,
    mode: 'onChange',
    defaultValues: {
      oldPassword: '',
      password: '',
      passwordConfirmation: '',
    },
  });

  const onSubmit = React.useCallback(
    async (values) => {
      try {
        const result = await mutateAsync(values);
        close();
        notification.success({ message: result.message });
      } catch (error) {
        if (error.errors) {
          formSetErrors(error.errors, methods.setError);
        }
        notification.error({ message: error.message });
      }
    },
    [close, methods.setError, mutateAsync],
  );

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <FormHeader
        onDelete={() => {}}
        noDelete
        title={t('common:change_password')}
      />
      <div>
        <HalfContainer>
          <Input
            type="password"
            name="oldPassword"
            label={t('common:old_password')}
            placeholder={t('common:old_password')}
            required
          />
          <Input
            type="password"
            name="password"
            label={t('common:password')}
            placeholder={t('common:password')}
            required
          />
          <Input
            type="password"
            name="passwordConfirmation"
            label={t('common:password_confirmation')}
            placeholder={t('common:password_confirmation')}
            required
          />
        </HalfContainer>
      </div>
    </Form>
  );
}
